import { get } from 'lodash';

const engineMixpanel = get(window, 'skeletonPwa.container.mixpanelService', {
  // tslint:disable-next-line:no-console
  track: (...args: any[]) => console.info('mixPanel tracking: ', args),
});

export const mixpanelService: {
  track: (event: string, metadata?: Record<string, string | number | undefined | null>) => void;
} = {
  track: (event, metadata = {}) => {
    const { category, ...restMeta } = metadata;

    return engineMixpanel.track(event, {
      category: category ? category : 'D P360',
      ...restMeta,
    });
  },
};
